<po-widget (click)="openDetail(item)" class="po-lg-6 po-mb-1 clickable-card"
    *ngFor="let item of inventoryCounts; let i = index">
    <div class="po-row po-pb-1" style="border-bottom: 1px solid #d3d3d3;">
                <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-row justify-center po-mb-1">
            <po-tag [p-value]="getStatusLabel(item.inventoryCountStatus)"
                [p-type]="getStatusColor(item.inventoryCountStatus)"></po-tag>
        </div>
        <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12">
            <span class="po-text-color-01 po-font-text-bold">Código:</span>
            <span class="po-ml-1">{{ item.inventoryCountCode }}</span>
        </div>
    </div>
    <div class="po-row po-pt-1">
        <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12">
            <span class="po-text-color-01 po-font-text-bold">Balanço:</span>
            <span class="po-ml-1">{{ item.inventoryCode }}</span>
        </div>
    </div>
    <div class="po-row po-pt-1">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12" [title]="item.inventoryCountDescription">
            <div style="display:flex-inline">
                <span class="po-text-color-01 po-font-text-bold">Descrição:</span>
                <span class="po-ml-1 add-dots">{{item.inventoryCountDescription}}</span>
            </div>
        </div>
    </div>
    <div class="po-row po-pt-1">
        <div class="po-xl-6 po-lg-6 po-md-6 po-sm-12">
            <span class="po-text-color-01 po-font-text-bold">Data da Contagem:</span>
            <span class="po-ml-1">{{item.inventoryCountDate | date:'dd/MM/yyyy' }}</span>
        </div>
    </div>
</po-widget>